import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const DrawerContext = createContext(null);

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within a DrawerProvider');
  }
  return context;
};

export const DrawerProvider = ({ children }) => {
  const [drawerCount, setDrawerCount] = useState(0);

  const openDrawer = useCallback(() => setDrawerCount(c => c + 1), []);
  const closeDrawer = useCallback(() => setDrawerCount(c => Math.max(0, c - 1)), []);
  const isDrawerOpen = drawerCount > 0;

  const value = useMemo(() => ({
    isDrawerOpen,
    openDrawer,
    closeDrawer,
  }), [isDrawerOpen, openDrawer, closeDrawer]);

  return (
    <DrawerContext.Provider value={value}>
      {children}
    </DrawerContext.Provider>
  );
};
